<script lang="ts" context="module">
  import { KIND, SIZE } from "@/libs/ui/Button"

  export { KIND, SIZE }
</script>

<script lang="ts">
  import { Button } from "@/libs/ui/Button"
  import { createEventDispatcher } from "svelte"

  export let isDisabled = false
  export let kind: KIND | undefined = undefined
  export let size: SIZE | undefined = undefined
  export let accept = "image/*"

  const dispatch = createEventDispatcher<{ upload: File }>()

  const onFileUpload = ({ currentTarget }: { currentTarget: HTMLInputElement }) => {
    const file = currentTarget.files?.[0]

    if (file) dispatch("upload", file)

    currentTarget.value = "" // reset the input value to allow uploading the same file again, https://stackoverflow.com/a/60886920
  }
</script>

<Button as="label" disabled={isDisabled} {kind} {size} class={$$restProps.class}>
  <slot></slot>
  <input
    class="absolute hidden"
    type="file"
    {accept}
    on:input={onFileUpload}
    disabled={isDisabled}
  />
</Button>
